import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FileDown } from "lucide-react";
import { api, errMsg, download, today } from "@/lib/api";
import { PageHeader } from "@/components/Common";
import { PnFiltri, PnTabella, PnTabs } from "@/components/PrimaNotaParts";
import { Contabilita } from "@/components/coge/Contabilita";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function StudioPrimaNota() {
  const [aziende, setAziende] = useState([]);
  const [cid, setCid] = useState("");
  const [f, setF] = useState({ dal: `${today().slice(0, 4)}-01-01`, al: today(), conto_id: "" });
  const [rep, setRep] = useState(null);
  const [err, setErr] = useState("");
  const [tab, setTab] = useState("cassa");
  useEffect(() => { api.get("/studio/overview").then((r) => setAziende(r.data.companies)); }, []);
  useEffect(() => {
    if (!cid) return;
    setRep(null); setErr("");
    api.get(`/studio/primanota/${cid}`, { params: f }).then((r) => setRep(r.data)).catch((e) => setErr(errMsg(e)));
  }, [cid, f]);
  return (
    <div>
      <PageHeader title="Contabilità clienti" subtitle="Prima nota e contabilità delle aziende che ti hanno autorizzato">
        <Select value={cid} onValueChange={(v) => { setCid(v); setTab("cassa"); setF({ ...f, conto_id: "" }); }}>
          <SelectTrigger className="w-72 bg-white" data-testid="studio-pn-company"><SelectValue placeholder="Scegli l'azienda" /></SelectTrigger>
          <SelectContent>{aziende.map((c) => <SelectItem key={c.id} value={c.id}>{c.denominazione}</SelectItem>)}</SelectContent>
        </Select>
        {rep && tab === "cassa" && <Button variant="outline" className="bg-white" data-testid="studio-pn-pdf" onClick={() => download(`/studio/primanota/${cid}/pdf`, f).catch((e) => toast.error(e.message))}><FileDown className="mr-2 h-4 w-4" />PDF</Button>}
      </PageHeader>
      {!cid && <p className="text-sm text-slate-600">Scegli un'azienda per vedere la sua prima nota.</p>}
      {err && <p className="rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900" data-testid="studio-pn-error">{err}</p>}
      {rep && <PnTabs tab={tab} setTab={setTab} regime={rep.regime} />}
      {rep && (tab === "cassa" ? <><PnFiltri f={f} set={setF} conti={rep.conti} /><PnTabella rep={rep} /></> : <Contabilita key={cid} base={`/studio/coge/${cid}`} kind={tab} regime={rep.regime} />)}
    </div>
  );
}
